let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://atmajaya-opr.digimasia.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://atmajaya-opr.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://atmajaya-opr.digimasia.com"
} else if (environment === "staging") {
  baseUrl =
    "https://atmajaya-opr-staging.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://atmajaya-opr-staging.digimasia.com"
} else {
  baseUrl =
    "https://atmajaya-opr-staging.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://atmajaya-opr-staging.digimasia.com"
}

export { baseUrlOrigin };
export default baseUrl;
